module.exports = __webpack_public_path__ + "media/assets/images/flags/nz-846a717bc22eefe3351417587568a60c.svg";